import { Component, NgZone, OnInit, ViewChild } from '@angular/core';

import { AlertController, IonRouterOutlet, isPlatform, MenuController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';

import { OfflineStorageService } from './services/offline-storage.service';
import { INTRO_KEY } from 'src/app/guards/intro.guard';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { getLoading } from './store/selectors/shared.selector';
import * as fromAuthActions from './store/actions/auth.actions'
import { App, AppInfo, URLOpenListenerEvent } from '@capacitor/app';
import { getCurrentRoute } from './store/selectors/router.selector';
import { AutoCloseOverlaysService } from './services/autocloseoverlays.service';
import { getUserSession } from 'src/app/store/selectors/auth.selectors';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { Router } from "@angular/router";
import { Market } from '@awesome-cordova-plugins/market/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  appPages = [
    {
      title: 'Dashboard',
      url: '/home/bottom-tabs/dashboard',
      icon: 'home'
    },
  ];

  loggedIn: any;

  dark = false;
  swipeGesture = false;
  disabledMenu = true;

  showLoading$: Observable<boolean>;
  currentRoute$: Observable<any>;
  currentPage = '';
  userSession$: Observable<any>;
  userSession = null;

  homeTab = 0;
  profileTab = -1;
  notificationTab = -1;
  rideTab = -1;
  otherTab = -1;

  homePages = ["dashboard"];
  profilePages = ["profile"];
  notificationPages = ["notifications"];
  ridePages = ["ride", "premium-ride"];
  otherPages = ["calendar", "points", "token", "pass"];

  fcmToken = '';

  appInfo: AppInfo;

  @ViewChild(IonRouterOutlet, { static : true }) ionRouterOutlet: IonRouterOutlet;

  constructor(
    private menu: MenuController,
    private offlineStorageService: OfflineStorageService,
    private store: Store<AppState>,
    private platform: Platform,
    private navCtrl: NavController,
    private ngZone: NgZone,
    private autoCloseOverlaysService: AutoCloseOverlaysService,
    private alertController: AlertController,
  ) {
    this.initializeApp();
  }

  async ngOnInit() {
    console.log('AppComponent ngOnInit');
  }

  initializeApp() {

    this.platform.ready().then(async () => {

      this.userSession$ = this.store.select(getUserSession);
      this.showLoading$ = this.store.select(getLoading);
      this.currentRoute$ = this.store.select(getCurrentRoute);

      this.userSession$.pipe().subscribe((userSession: any) => {
        console.log({userSession});
        this.userSession = userSession;
        // this.setUpDeepLink();
      });
      
      this.store.dispatch(fromAuthActions.autoLogin());

      // Back navigation 
      this.currentRoute$.subscribe((route) => {
        if (route && route.url ) {
          this.currentPage = route.url.substring(route.url.lastIndexOf('/') + 1);
          this.homeTab = this.homePages.indexOf(this.currentPage);
          this.profileTab = this.profilePages.indexOf(this.currentPage);
          this.rideTab = this.ridePages.indexOf(this.currentPage);
          this.notificationTab = this.notificationPages.indexOf(this.currentPage);
          this.otherTab = this.otherPages.indexOf(this.currentPage);
        }
      }); 

      window.addEventListener('navigation:back', async (e: any) => {
        console.log('navigation:back', e?.detail);
        const isNavigateBack = e?.detail;
        if (isNavigateBack) {
          if (this.ionRouterOutlet.canGoBack()) {
            if(this.homeTab >= 0 || this.profileTab >= 0 || this.notificationTab >= 0 || this.rideTab >= 0 || this.otherTab >= 0){
              console.log('confirmExit sa header');
              this.confirmExit();
            }
            else{
              this.ngZone.run(() => {
                console.log('BACK sa this.ionRouterOutlet.canGoBack()', this.ionRouterOutlet.canGoBack());
                this.navCtrl.pop();
              });
            }
          } else {
            if (this.homeTab > 0 || this.profileTab > 0 || this.notificationTab > 0 || this.rideTab > 0) {
              this.ngZone.run(() => {
                console.log('BACK sa this.homeTab > 0 || this.profileTab > 0 || this.moreTab > 0');
                this.navCtrl.back();
              });
            } else {
              console.log('confirmExit sa header');
              this.confirmExit();
            }
          }
        }
      });

      this.platform.backButton.subscribeWithPriority(999, async () => {
        console.log('Handler was called!');
        const hasClosedOverlays = await this.autoCloseOverlaysService.trigger();
        console.log({hasClosedOverlays});
        if (hasClosedOverlays) {
          console.log('do not back navigation, close overlays');
        } else {
            console.log('call navigate back event');
            window.dispatchEvent(new CustomEvent('navigation:back', { detail: true}));  
        }
      });

      // Logout
      window.addEventListener('auth:logout', (e: any) => {
        console.log('auth:logout', e?.detail);
        const isLogout = e?.detail;
        if (isLogout) {
          this.logout();
        }
      });

      // Session Timeout
      window.addEventListener('auth:timeout', (e: any) => {
        console.log('auth:timeout', e?.detail);
        const isTimeout = e?.detail;
        if (isTimeout && this.userSession) {
          this.autoCloseOverlaysService.trigger();
          this.logout();
          this.sessionTimeOut();
        }
      });

    });
  }

  // setUpDeepLink() {
  //   this.platform.ready().then(async () => {
  //     this.deeplinks.route({ 
  //       '/shopeepay/order-status/:orderId': 'home/bottom-tabs/token/token-order-history',
  //       '/:orderId': 'home/bottom-tabs/token/token-order-history',
  //     }).subscribe(
  //       match => {
  //         console.log('Successfully matched route', match);
  //         // Create our internal Router path by hand
  //         const internalPath = `/${match.$route}/${match.$args['orderId']}`;
  //         console.log({internalPath});
  //         // Run the navigation in the Angular zone
  //         this.ngZone.run(() => {
  //           this.router.navigateByUrl(internalPath);
  //         });
  //       },
  //       nomatch => {
  //         // nomatch.$link - the full link data
  //         console.error("Got a deeplink that didn't match", nomatch);
  //       }
  //     );
  //   });
  // }

  async confirmExit() {
    const isAlertOpen = await this.alertController.getTop();
    if(!isAlertOpen){
      const alert = await this.alertController.create({
        message: 'Do you want to exit the application?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            id: 'cancel-button',
            handler: (blah) => {
              console.log('Confirm Cancel: blah');
            }
          }, {
            text: 'Yes',
            id: 'confirm-button',
            handler: () => {
              App.exitApp();
            }
          }
        ]
      });
  
      await alert.present();
    }
  }

  async logout() {
    this.store.dispatch(fromAuthActions.autoLogout());
  }

  async openIntro() {
    this.menu.enable(false);
    this.offlineStorageService.setObject(INTRO_KEY, false);
    this.navCtrl.navigateRoot('auth');
  }

  async sessionTimeOut() {
    const alert = await this.alertController.create({
      message: "Session Timeout!",
      backdropDismiss: false,
      buttons: [
        {
          text: "OK",
          handler: async () => {
            
          },
        },
      ],
    });
    await alert.present();
  }
}
